import { ERROR_PREFIXES } from 'src/common/constants';
import { createDatadogError } from 'src/services/datadog/utils/createDatadogError';

export const RefreshTokenError = createDatadogError('RefreshToken', ERROR_PREFIXES.OAUTH);
